import { ButtonMobile as Button, ButtonMobile } from '@tui-react/button';
import cn from 'classnames';
import React, { ComponentProps } from 'react';
import styles from './ThemedButton.module.css';

interface ThemedButtonProps extends Omit<ComponentProps<typeof Button>, 'type'> {
  className?: string;
}

export const ThemedButton: React.FC<ThemedButtonProps> = ({ className, wide = true, ...props }) => {
  return (
    <div className={cn(className, styles.buttonWrapper)}>
      <ButtonMobile type="button" {...props} wide={wide} appearance="flat" />
    </div>
  );
};
